import { Maybe } from "@/src/types/gql-types";

export const toDateFromString = (
  dateString: Maybe<string>,
): Date | undefined => {
  if (dateString) {
    const date = new Date(dateString);

    if (!isNaN(date.getTime())) {
      return date;
    }
  }

  return;
};
